export default __webpack_public_path__ + "static/media/sin-comunicaciones.6c0e2f52.png";